// src/components/admin/TestimonialsEditor.js
import React, { useState } from 'react';
import './EditorStyles.css';

const TestimonialsEditor = () => {
  const [testimonials, setTestimonials] = useState([
    {
      id: 1,
      name: "John Smith",
      position: "CEO, ABC Company",
      content: "This company provided excellent service. Very professional and responsive.",
      rating: 5,
      imageUrl: "/path/to/testimonial1.jpg"
    },
    {
      id: 2,
      name: "Sarah Johnson",
      position: "Marketing Director, XYZ Corp",
      content: "Outstanding work and attention to detail. Would highly recommend!",
      rating: 5,
      imageUrl: "/path/to/testimonial2.jpg"
    }
  ]);
  
  const [currentTestimonial, setCurrentTestimonial] = useState(null);
  const [sectionTitle, setSectionTitle] = useState("What Our Clients Say");
  
  const handleAddTestimonial = () => {
    const newTestimonial = {
      id: Date.now(),
      name: "New Client",
      position: "Client Position",
      content: "Enter testimonial text here",
      rating: 5,
      imageUrl: "/path/to/placeholder.jpg"
    };
    
    setTestimonials([...testimonials, newTestimonial]);
    setCurrentTestimonial(newTestimonial);
  };
  
  const handleEditTestimonial = (testimonial) => {
    setCurrentTestimonial({...testimonial});
  };
  
  const handleDeleteTestimonial = (testimonialId) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      setTestimonials(testimonials.filter(t => t.id !== testimonialId));
      if (currentTestimonial && currentTestimonial.id === testimonialId) {
        setCurrentTestimonial(null);
      }
    }
  };
  
  const handleTestimonialChange = (e) => {
    const { name, value } = e.target;
    setCurrentTestimonial(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleRatingChange = (rating) => {
    setCurrentTestimonial(prev => ({
      ...prev,
      rating
    }));
  };
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentTestimonial(prev => ({
          ...prev,
          imageUrl: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  
  const handleSaveTestimonial = () => {
    setTestimonials(testimonials.map(t => 
      t.id === currentTestimonial.id ? currentTestimonial : t
    ));
    
    alert("Testimonial saved successfully!");
  };
  
  const handleSaveAll = () => {
    // Here you would save all testimonials to your backend
    console.log("Saving all testimonials:", { sectionTitle, testimonials });
    alert("All changes saved successfully!");
  };
  
  return (
    <div className="section-editor">
      <h2>Edit Testimonials Section</h2>
      
      <div className="form-group">
        <label>Section Title</label>
        <input 
          type="text" 
          value={sectionTitle}
          onChange={(e) => setSectionTitle(e.target.value)}
        />
      </div>
      
      <div className="testimonials-list">
        <h3>Testimonials List</h3>
        <div className="testimonials-grid">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-item">
              <h4>{testimonial.name}</h4>
              <p>{testimonial.position}</p>
              <div className="testimonial-actions">
                <button 
                  className="edit-button"
                  onClick={() => handleEditTestimonial(testimonial)}
                >
                  Edit
                </button>
                <button 
                  className="delete-button"
                  onClick={() => handleDeleteTestimonial(testimonial.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
          <button className="add-testimonial-button" onClick={handleAddTestimonial}>
            + Add New Testimonial
          </button>
        </div>
      </div>
      
      {currentTestimonial && (
        <div className="testimonial-editor">
          <h3>Edit Testimonial</h3>
          
          <div className="form-group">
            <label>Client Name</label>
            <input 
              type="text"
              name="name"
              value={currentTestimonial.name}
              onChange={handleTestimonialChange}
            />
          </div>
          
          <div className="form-group">
            <label>Client Position/Company</label>
            <input 
              type="text"
              name="position"
              value={currentTestimonial.position}
              onChange={handleTestimonialChange}
            />
          </div>
          
          <div className="form-group">
            <label>Testimonial Text</label>
            <textarea
              name="content"
              value={currentTestimonial.content}
              onChange={handleTestimonialChange}
              rows="4"
            />
          </div>
          
          <div className="form-group">
            <label>Rating (1-5)</label>
            <div className="rating-selector">
              {[1, 2, 3, 4, 5].map(star => (
                <span
                  key={star}
                  className={`star ${currentTestimonial.rating >= star ? 'filled' : ''}`}
                  onClick={() => handleRatingChange(star)}
                >
                  ★
                </span>
              ))}
            </div>
          </div>
          
          <div className="form-group">
            <label>Client Photo</label>
            <div className="image-preview">
              <img src={currentTestimonial.imageUrl} alt={currentTestimonial.name} />
            </div>
            <input 
              type="file" 
              accept="image/*"
              onChange={handleImageChange}
            />
          </div>
          
          <button 
            className="save-button"
            onClick={handleSaveTestimonial}
          >
            Save Testimonial
          </button>
        </div>
      )}
      
      <div className="form-actions">
        <button 
          className="save-all-button"
          onClick={handleSaveAll}
        >
          Save All Changes
        </button>
      </div>
    </div>
  );
};

export default TestimonialsEditor;